module.exports = __webpack_public_path__ + "static/media/spring-che-small-mobile@2x.93c4fcfd.png";